module.exports = __webpack_public_path__ + "index/img/zhuanshi.1deed370.png";